import { CurrencyEnum } from '@/store/types'
import usdtLogo from '@/assets/img/tether-usdt-logo.png'

const countryCodeMap: Record<CurrencyEnum, string> = {
  [CurrencyEnum.USD]: 'us',
  [CurrencyEnum.EUR]: 'eu',
  [CurrencyEnum.AED]: 'ae',
  [CurrencyEnum.CNY]: 'cn',
  [CurrencyEnum.USDT]: 'us'
}

export const getCurrencyFlagUrl = (currency: CurrencyEnum): string => {
  if (currency === CurrencyEnum.USDT) {
    return usdtLogo
  }
  return `https://flagcdn.com/w40/${countryCodeMap[currency]}.png`
} 